import MainTitle from '../../common/MainTitle';
import Icon from '../../common/Icon';
import ImageLink from '../../../js/utils/ImageLink';

export default function AcademicCalendar({ titles, data }) {
  return (
    <section className="academic-calendar">
      <MainTitle type="dark" className="text--2xl container hidden--lg">
        <span>{titles?.title1}</span>
        <span className="decorated-line decorated-line--dark decorated-line--left">
          {titles?.title2}
        </span>
      </MainTitle>

      <div className="academic-calendar__container container">
        <div className="academic-calendar__content">
          <MainTitle type="dark" className="text--2xl container hidden--md">
            <span>{titles?.title1}</span>
            <span className="decorated-line decorated-line--dark decorated-line--left">
              {titles?.title2}
            </span>
          </MainTitle>

          <div className="academic-calendar__description">
            <p className="description">{data?.description}</p>

            {!!data?.downloadFile && (
              <a
                className="academic-calendar__download"
                href="/Academic_Calendar.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download>
                <Icon name="download" />
                <span>{data?.linkText}</span>
              </a>
            )}
          </div>
        </div>
        <div className="academic-calendar__media">
          <img src={ImageLink(data?.image.url)} alt={data?.image.alt} />
        </div>
      </div>
    </section>
  );
}
